module.exports = {"apis":{"aws":"https://dawa.aws.dk/","relevant":"https://worker30-api.relevant-digital.com/"}};